import http from "../../../core/utils/apis/api";

const getUsersList = async (options) => {
  try {
    const response = await http({
      method: "GET",
      url: "/users",
      params: options,
    });
    return response;
  } catch (e) {
    throw e;
  }
};

const changeUserStatus = async (userId) => {
  try {
    const response = await http({
      method: "PUT",
      url: `/users/${userId}/change-status`,
    });
    return response;
  } catch (e) {
    throw e;
  }
};

const updateRolesUser = async (userId, listRoleUser) => {
  try {
    const response = await http({
      method: "PATCH",
      url: `/users/${userId}/roles`,
      data: listRoleUser,
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (e) {
    throw e;
  }
};

const userManagementService = {
  getUsersList,
  changeUserStatus,
  updateRolesUser,
};

export default userManagementService;
